import { useTranslation } from 'react-i18next';

import { checkLocalizationDefinitions, traverseShape } from '@mssgme/i18n';
import en from '../locales/en/cards.json';
import ru from '../locales/ru/cards.json';

if (__DEV__) {
    checkLocalizationDefinitions([en, ru]);
}

const traversedLocales = traverseShape(en);

export function useCardsTranslation() {
    const { t, ...rest } = useTranslation('cards');

    return {
        keys: traversedLocales,
        t,
        ...rest,
    };
}
